// src/com/file_create_his/FileCreateHisGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * FILE_CREATE_HIS Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-10-11 10:13:46 using DbdbTap.
 ************************************************ */

const FILE_CREATE_HIS_LIST_PART = gql`
fragment FileCreateHisListPart on FileCreateHis {
    fileCreateHisSeq
    dcCd
    fileDownUp
    fileFlag
    menuName
    serverUrl
    fileAddr
    fileTitle
    fileName
    fileSize
    fileExt
    regUser
    regDate
    regUserName
}
`;

/* export const LIST_FILE_CREATE_HIS = gql`
${FILE_CREATE_HIS_LIST_PART}
query ListFileCreateHis($fileCreateHisSeq:Int!) {
    fileCreateHisList(fileCreateHisSeq:$fileCreateHisSeq) {
        ...FileCreateHisListPart
    }
}
`; */
/*

	fileCreateHisDeliveryReportList(dateFrom:String!, dateTill:String!): [FileCreateHis]!
    fileCreateHisTransportReportList(dateFrom:String!, dateTill:String!): [FileCreateHis]!
    fileCreateHisArrivalOnTimeReportList(dateFrom:String!, dateTill:String!): [FileCreateHis]!
    fileCreateHisTemperatureReportList(dateFrom:String!, dateTill:String!): [FileCreateHis]!
    fileCreateHisTsrResultReportList(dateFrom:String!, dateTill:String!): [FileCreateHis]!
    fileCreateHisStoreTransportReportList(dateFrom:String!, dateTill:String!): [FileCreateHis]!
*/


// 출고실적 리포트
export const LIST_FILE_CREATE_HIS_DELIVERY_REPORT = gql`
${FILE_CREATE_HIS_LIST_PART}
query ListFileCreateHisDeliveryReport($dateFrom:String!, $dateTill:String!) {
    fileCreateHisDeliveryReportList(dateFrom:$dateFrom, dateTill:$dateTill) {
        ...FileCreateHisListPart
    }
}
`;

// 운송실적 리포트
export const LIST_FILE_CREATE_HIS_TRANSPORT_REPORT = gql`
${FILE_CREATE_HIS_LIST_PART}
query ListFileCreateHisTransportReport($dateFrom:String!, $dateTill:String!) {
    fileCreateHisTransportReportList(dateFrom:$dateFrom, dateTill:$dateTill) {
        ...FileCreateHisListPart
    }
}
`;

// 정시도착 리포트
export const LIST_FILE_CREATE_HIS_ARRIVAL_ON_TIME_REPORT = gql`
${FILE_CREATE_HIS_LIST_PART}
query ListFileCreateHisArrivalOnTimeReport($dateFrom:String!, $dateTill:String!) {
    fileCreateHisArrivalOnTimeReportList(dateFrom:$dateFrom, dateTill:$dateTill) {
        ...FileCreateHisListPart
    }
}
`;

// 온도관제 리포트
export const LIST_FILE_CREATE_HIS_TEMPERATURE_REPORT = gql`
${FILE_CREATE_HIS_LIST_PART}
query ListFileCreateHisTemperatureReport($dateFrom:String!, $dateTill:String!) {
    fileCreateHisTemperatureReportList(dateFrom:$dateFrom, dateTill:$dateTill) {
        ...FileCreateHisListPart
    }
}
`;

// TSR결과 리포트
export const LIST_FILE_CREATE_HIS_TSR_RESULT_REPORT = gql`
${FILE_CREATE_HIS_LIST_PART}
query ListFileCreateHisTsrResultReport($dateFrom:String!, $dateTill:String!) {
    fileCreateHisTsrResultReportList(dateFrom:$dateFrom, dateTill:$dateTill) {
        ...FileCreateHisListPart
    }
}
`;

// 점포운송 리포트
export const LIST_FILE_CREATE_HIS_STORE_TRANSPORT_REPORT = gql`
${FILE_CREATE_HIS_LIST_PART}
query ListFileCreateHisStoreTransportReport($dateFrom:String!, $dateTill:String!) {
    fileCreateHisStoreTransportReportList(dateFrom:$dateFrom, dateTill:$dateTill) {
        ...FileCreateHisListPart
    }
}
`;

// 센터 운송요청 다운로드.
// fileCreateHisDcTransPlanHistoryFileList(dateFrom:String!, dateTill:String!): [FileCreateHis]!
export const LIST_FILE_CREATE_HIS_DC_TRANS_PLAN_HISTORY_FILE = gql`
${FILE_CREATE_HIS_LIST_PART}
query ListFileCreateHisDcTransPlanHistoryFile($dateFrom:String!, $dateTill:String!) {
    fileCreateHisDcTransPlanHistoryFileList(dateFrom:$dateFrom, dateTill:$dateTill) {
        ...FileCreateHisListPart
    }
}
`;

// fileCreateHisItem(fileCreateHisSeq:Int!): FileCreateHis
export const GET_FILE_CREATE_HIS = gql`
${FILE_CREATE_HIS_LIST_PART}
query GetFileCreateHis($fileCreateHisSeq:Int!) {
    fileCreateHisItem(fileCreateHisSeq:$fileCreateHisSeq) {
        ...FileCreateHisListPart
    }
}
`;


export const REMOVE_FILE_CREATE_HIS = gql`
mutation RemoveFileCreateHis($fileCreateHis:InputFileCreateHisRemove!) {
	fileCreateHisRemove(fileCreateHis: $fileCreateHis) {
		ok
		message
	}
}
`;

// fileCreateHisUrl(fileCreateHisSeq:Int!, serverUrl: String!): ResponseWithFileCreateHisItem!
export const GET_FILE_CREATE_HIS_URL = gql`
query GetFileCreateHisUrl($fileCreateHisSeq:Int!, $serverUrl: String!) {
    fileCreateHisUrl(fileCreateHisSeq:$fileCreateHisSeq, serverUrl:$serverUrl) {
        ok
        message
        item {
            fileCreateHisSeq
            serverUrl
            fileAddr
        }
    }
}
`;
